import { StyledButton } from '@portalCommon/components/StyledButton';
import { toContactPage } from '@portalCommon/utils';
import { CenterCoverImg } from '@commonPackage/components';
import classnames from 'classnames/bind';
import { ContactType } from 'common-package';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export const PageTop = ({
  title,
  brief,
  bg,
  type = 'primary',
}: {
  title: string;
  brief: string;
  bg: string;
  type?: string;
}) => {
  return (
    <div className={cx('page-top-container')}>
      <div className={cx('content')}>
        <div className={cx('title', { white: type === 'primary' })}>{title}</div>
        <div className={cx('subtitle', { white: type === 'primary' })}>{brief}</div>
        <StyledButton
          styleType="gradient"
          className={cx('btn')}
          onClick={() =>
            toContactPage({ contactType: ContactType.activity, isMain: import.meta.env.VITE_MAIN === 'true' })
          }>
          定 制 专 属 解 决 方 案
        </StyledButton>
      </div>
      <CenterCoverImg width={1920} alt={title} src={bg} />
    </div>
  );
};
